import React from "react";
import Lottie from "react-lottie";

const Anim = (props) => {
  var defaultOptions = {
    loop: props.loop,
    autoplay: true,
    animationData: props.animationData.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <br />
      <br />
      <Lottie
        options={defaultOptions}
        height={props.height}
        width={props.width}
      />
    </>
  );
};

export default Anim;
